import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setNotFound(false);
    setP(null);
    api.get(`/cms/posts/${slug}`)
      .then(({ data }) => setP(data))
      .catch((err) => {
        if (err?.response?.status === 404) setNotFound(true);
        // Non-404 errors: leave loading state; the global axios logger
        // has already surfaced the issue in the console for ops.
      });
  }, [slug]);

  if (notFound) {
    return (
      <div className="py-32 text-center">
        <div className="text-[10px] uppercase tracking-widest text-white/40 font-mono">Post not found</div>
        <h1 className="font-display text-3xl mt-4 tracking-tight">That article does not exist.</h1>
        <p className="mt-3 text-sm text-white/60">It may have been unpublished or the URL is off.</p>
        <Link to="/blog" className="inline-flex items-center gap-2 mt-8 px-5 py-2.5 rounded-full border border-white/15 hover:bg-white/5 text-sm">
          <ArrowLeft className="w-4 h-4" /> Back to blog
        </Link>
      </div>
    );
  }
  if (!p) return <div className="py-32 text-center text-white/50">Loading…</div>;

  return (
    <div className="py-20">
      <article className="mx-auto max-w-3xl px-6 lg:px-10">
        <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white">
          <ArrowLeft className="w-4 h-4" /> All updates
        </Link>
        {p.cover_image && (
          <div className="mt-8 rounded-3xl overflow-hidden glass">
            <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover" />
          </div>
        )}
        <div className="mt-10 text-[11px] uppercase tracking-widest text-white/40 font-mono">
          {(p.tags || []).join(" · ")} · {p.author}
        </div>
        <h1 className="font-display text-4xl lg:text-5xl mt-3 tracking-tighter">{p.title}</h1>
        <div className="mt-8 text-white/80 leading-relaxed whitespace-pre-line">{p.body}</div>
      </article>
    </div>
  );
}
